import { getEcsConfig } from '@ms/yammer-data/dist/domains/ecs/selectors';

import { useSelector } from '../useSelector';

type UseEcsConfig = () => ReturnType<typeof getEcsConfig>;
export const useEcsConfig: UseEcsConfig = () => useSelector(getEcsConfig);
